<app-para-drawer
	[isOpen]="drawerOpen"
	[student]="activeStudent"
	[studentBadgeMilestoneOverlay]="lmsStudentBadgeMilestoneOverlay"
	[showHeaderCenter]="true"
	(close)="closeDrawer()"
>
	<app-para-milestone-status-strip
		headerLeft
		[milestones]="lmsMilestonesWithStatus"
	></app-para-milestone-status-strip>

	<div
		headerCenter
		class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-0.5 tw-min-w-0 tw-w-full tw-text-center"
	>
		<div
			*ngIf="lmsChallengeNavLabel || lmsCurrentChallengeLabel"
			class="tw-flex tw-flex-col tw-items-center tw-gap-0.5 tw-min-w-0 tw-w-full tw-max-w-full"
			aria-label="Challenge progress"
		>
			<span class="tw-text-[10px] tw-font-bold tw-uppercase tw-tracking-wider tw-text-slate-400 tw-max-w-full max-sm:tw-truncate">Challenge</span>
			<span *ngIf="lmsChallengeNavLabel" class="tw-text-xs tw-font-semibold tw-text-slate-700 tw-tabular-nums tw-max-w-full max-sm:tw-truncate sm:tw-whitespace-normal">{{ lmsChallengeNavLabel }}</span>
			<span
				*ngIf="lmsCurrentChallengeLabel"
				class="tw-block tw-w-full tw-min-w-0 tw-max-w-full max-sm:tw-truncate sm:tw-whitespace-normal tw-text-xs sm:tw-text-[13px] tw-font-semibold tw-text-slate-700 tw-leading-snug"
				[title]="lmsCurrentChallengeLabel"
			>{{ lmsCurrentChallengeLabel }}</span>
		</div>
	</div>

	<div headerActions class="tw-flex tw-items-center tw-gap-2 sm:tw-gap-3 tw-shrink-0">
		<button
			*ngIf="lmsActiveSlideGuideLines.length"
			type="button"
			data-testid="para-lms-slide-guide-show"
			(click)="toggleLmsSlideGuide()"
			class="tw-inline-flex tw-h-10 tw-min-w-[8.75rem] tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-lg tw-border tw-px-2.5 tw-text-xs tw-font-semibold tw-text-slate-700 tw-cursor-pointer tw-whitespace-nowrap"
			[ngClass]="lmsSlideGuideVisible
				? 'tw-border-slate-300 tw-bg-white tw-shadow-sm'
				: 'tw-border-slate-200 tw-bg-slate-50 hover:tw-border-slate-300 hover:tw-bg-white'"
			[attr.aria-expanded]="lmsSlideGuideVisible"
			aria-controls="para-lms-slide-guide-panel"
		>
			<i class="fa fa-info-circle tw-text-slate-500" aria-hidden="true"></i>
			Scoring guide
		</button>

		<button
			*ngIf="showLmsHeaderSubmit()"
			type="button"
			data-testid="para-lms-header-submit"
			(click)="goToConfirmation()"
			class="tw-inline-flex tw-h-10 tw-shrink-0 tw-items-center tw-gap-1.5 tw-rounded-lg tw-border tw-border-[#28A745] tw-bg-[#28A745] tw-px-4 tw-text-sm tw-font-semibold tw-text-white tw-shadow-sm tw-transition-colors hover:tw-bg-[#218838] tw-cursor-pointer">
			Submit ({{ scoreStorageService.count }})
			<i class="fa fa-check tw-text-[10px]" aria-hidden="true"></i>
		</button>
	</div>

	<div
		subHeader
		*ngIf="lmsActiveSlideGuideLines.length"
		class="tw-pointer-events-none tw-h-0 tw-overflow-visible"
	>
		<div
			*ngIf="lmsSlideGuideVisible"
			id="para-lms-slide-guide-panel"
			data-testid="para-lms-slide-guide-panel"
			class="tw-pointer-events-auto tw-fixed tw-z-10 tw-max-w-[min(100vw-2rem,22rem)] tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-p-5 tw-pr-11 tw-shadow-lg"
			[ngStyle]="lmsSlideGuidePanelStyle"
			aria-label="Scoring guidance for this slide"
		>
			<button
				type="button"
				data-testid="para-lms-slide-guide-hide"
				(click)="toggleLmsSlideGuide()"
				class="tw-absolute tw-top-2 tw-right-2 tw-inline-flex tw-h-7 tw-w-7 tw-items-center tw-justify-center tw-rounded-md tw-text-slate-400 hover:tw-bg-slate-100 hover:tw-text-slate-700"
				aria-label="Hide scoring guide"
			>
				<i class="fa fa-times tw-text-xs" aria-hidden="true"></i>
			</button>
			<p
				*ngFor="let line of lmsActiveSlideGuideLines; let last = last"
				class="tw-m-0 tw-text-sm tw-leading-relaxed tw-text-slate-700"
				[class.tw-mb-3]="!last"
			>
				<ng-container *ngFor="let segment of lmsSlideGuideLineSegments(line)">
					<ng-container [ngSwitch]="segment.kind">
						<span *ngSwitchCase="'text'">{{ segment.text }}</span>
						<span *ngSwitchCase="'trailingPoints'">{{ segment.text }}<span class="tw-inline-flex tw-whitespace-nowrap tw-items-center tw-align-middle">{{ segment.separator }}<span class="tw-inline-flex tw-h-8 tw-min-w-[2rem] tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-[#5a6ea8] tw-bg-[#243670] tw-px-2.5 tw-text-sm tw-font-bold tw-leading-none tw-text-white tw-ml-0.5">{{ segment.label }}</span></span></span>
						<span
							*ngSwitchCase="'points'"
							class="tw-inline-flex tw-h-8 tw-min-w-[2rem] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-[#5a6ea8] tw-bg-[#243670] tw-px-2.5 tw-text-sm tw-font-bold tw-leading-none tw-text-white tw-whitespace-nowrap tw-align-middle tw-mx-0.5"
						>{{ segment.label }}</span>
						<span
							*ngSwitchCase="'nextControl'"
							class="tw-inline-flex tw-items-center tw-whitespace-nowrap tw-align-middle tw-gap-x-0.5 tw-mx-0.5"
						>
							<span>Click the</span>
							<span class="tw-inline-flex tw-h-8 tw-min-w-[3.25rem] tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-[#5a6ea8] tw-bg-[#243670] tw-px-3.5 tw-text-xs tw-font-bold tw-leading-none tw-tracking-wider tw-text-white">NEXT</span>
							<span>button</span>
						</span>
					</ng-container>
				</ng-container>
			</p>
		</div>
	</div>

	<!-- Main Body: Iframe and Scoring UI -->
	<div class="drawer-body tw-relative tw-flex-1 tw-min-h-0 tw-overflow-hidden tw-flex tw-flex-col tw-bg-para-primary">
		<!-- Locked Banner -->
		<div *ngIf="isLocked" class="tw-bg-amber-50 tw-border-b tw-border-amber-200 tw-px-6 tw-py-3.5 tw-flex tw-items-center tw-justify-between tw-shrink-0 tw-z-20 tw-shadow-sm">
			<div class="tw-flex tw-items-start tw-gap-3.5">
				<div class="tw-w-8 tw-h-8 tw-rounded-full tw-bg-amber-100 tw-text-amber-600 tw-flex tw-items-center tw-justify-center tw-shrink-0 tw-mt-0.5">
					<i class="fa fa-lock tw-text-sm"></i>
				</div>
				<div class="tw-flex tw-flex-col tw-gap-0.5">
					<span class="tw-text-amber-900 tw-font-bold tw-text-[14px]">Assessment is Locked (Read-Only)</span>
					<span class="tw-text-amber-700 tw-text-[13px] tw-leading-snug">{{ lockReason || 'Scores cannot be edited or submitted for this assessment.' }}</span>
				</div>
			</div>
			<button type="button" (click)="returnToScreener()" class="tw-shrink-0 tw-ml-4 tw-text-[13px] tw-font-bold tw-text-amber-700 hover:tw-text-amber-900 tw-underline tw-underline-offset-2 tw-bg-transparent tw-border-0 tw-p-0 tw-cursor-pointer focus:tw-outline-none">
				Return to Screener
			</button>
		</div>

		<div class="tw-relative tw-flex-1 tw-min-h-0 tw-w-full">
			<!-- Loading Spinner -->
			<div *ngIf="isLoadingIframe" class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-z-10">
				<div class="tw-flex tw-flex-col tw-items-center tw-gap-3">
					<div class="tw-w-12 tw-h-12 tw-border-4 tw-border-white/20 tw-border-t-white tw-rounded-full tw-animate-spin"></div>
					<span class="tw-text-white/60 tw-text-sm tw-font-medium">Loading story...</span>
				</div>
			</div>

			<iframe
				*ngIf="drawerOpen && iframeUrl"
				id="para-lms-assessment-frame"
				[src]="iframeUrl"
				(load)="onStoryIframeLoaded()"
				class="tw-absolute tw-inset-0 tw-h-full tw-w-full tw-border-0 tw-bg-para-primary tw-transition-opacity tw-duration-500"
				[class.tw-opacity-0]="isLoadingIframe"
				[class.tw-opacity-100]="!isLoadingIframe"
				style="background: transparent;"
				allowtransparency="true"
				title="Assessment story"></iframe>

			<!-- Empty/Error State -->
			<div
				*ngIf="drawerOpen && !iframeUrl"
				class="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-px-6 tw-py-10 tw-text-center tw-text-white/90">
				<p class="tw-m-0 tw-max-w-md tw-text-base">
					No story could be loaded for the current challenge. The phase may be complete, or challenge data may be missing from the server response.
				</p>
				<button
					type="button"
					class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-white tw-text-[#243670] tw-px-4 tw-py-2 tw-text-sm tw-font-medium hover:tw-opacity-95"
					(click)="closeDrawer()">
					Close
				</button>
			</div>
		</div>



		<!-- State Overlays -->
		<div
			*ngIf="drawerState === 'submitting'"
			class="overlay-fade tw-absolute tw-inset-0 tw-bg-white/95 tw-backdrop-blur-sm tw-z-20 tw-flex tw-items-center tw-justify-center">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" width="100" height="100">
				<radialGradient id="paraLmsSpinnerGrad" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
					<stop offset="0" stop-color="#243670"></stop>
					<stop offset=".3" stop-color="#243670" stop-opacity=".9"></stop>
					<stop offset=".6" stop-color="#243670" stop-opacity=".6"></stop>
					<stop offset=".8" stop-color="#243670" stop-opacity=".3"></stop>
					<stop offset="1" stop-color="#243670" stop-opacity="0"></stop>
				</radialGradient>
				<circle transform-origin="center" fill="none" stroke="url(#paraLmsSpinnerGrad)" stroke-width="15" stroke-linecap="round" stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
					<animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1" keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
				</circle>
				<circle transform-origin="center" fill="none" opacity=".2" stroke="#243670" stroke-width="15" stroke-linecap="round" cx="100" cy="100" r="70"></circle>
			</svg>
		</div>

		<div
			*ngIf="drawerState === 'done'"
			class="overlay-fade tw-absolute tw-inset-0 tw-bg-white/95 tw-backdrop-blur-sm tw-z-20 tw-flex tw-items-center tw-justify-center">
			<div class="success-pop tw-flex tw-flex-col tw-items-center tw-gap-6">
				<svg width="120px" height="120px" viewBox="0 0 133 133" version="1.1" xmlns="http://www.w3.org/2000/svg">
					<g id="para-lms-check-group" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
						<circle id="para-lms-filled-circle" fill="#07b481" cx="66.5" cy="66.5" r="54.5" />
						<circle id="para-lms-white-circle" fill="#FFFFFF" cx="66.5" cy="66.5" r="55.5" />
						<circle id="para-lms-outline" stroke="#07b481" stroke-width="4" cx="66.5" cy="66.5" r="54.5" />
						<polyline id="para-lms-check" stroke="#FFFFFF" stroke-width="5.5" points="41 70 56 85 92 49" />
					</g>
				</svg>
				<div class="tw-text-center">
					<h2 class="tw-text-2xl tw-font-bold tw-text-slate-900 tw-m-0">Assessment Complete!</h2>
					<p class="tw-text-slate-500 tw-mt-2">The scores have been successfully recorded.</p>
				</div>
			</div>
		</div>
	</div>
</app-para-drawer>

<ng-template #scoreReviewPortal>
	<div class="para-lms-score-review-overlay overlay-fade" role="dialog" aria-modal="true" aria-label="Review and submit scores">
		<div class="para-lms-score-review-overlay__backdrop" aria-hidden="true"></div>
		<div class="para-lms-score-review-overlay__card">
			<div class="tw-bg-[#243670] tw-px-4 tw-py-3 sm:tw-px-8 sm:tw-py-5 tw-flex tw-items-center tw-gap-3 sm:tw-gap-5 tw-shrink-0">
				<app-para-student-badge
					class="tw-w-10 tw-h-10 sm:tw-w-14 sm:tw-h-14 tw-shadow-md tw-shrink-0"
					[student]="activeStudent"
					[milestoneOverlay]="lmsStudentBadgeMilestoneOverlay"
				></app-para-student-badge>
				<div class="tw-min-w-0 tw-flex-1">
					<div class="tw-text-white/60 tw-text-[10px] sm:tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider">Review &amp; Submit</div>
					<div class="tw-text-white tw-text-lg sm:tw-text-2xl tw-font-black tw-leading-tight tw-mt-0.5 sm:tw-mt-1 tw-truncate">
						<span data-para-redact>{{ activeStudent?.student?.firstName }} {{ activeStudent?.student?.lastName }}</span>
					</div>
					<div *ngIf="activeStudent?.grade ?? activeStudent?.student?.grade" class="tw-text-white/70 tw-text-xs sm:tw-text-sm tw-font-semibold tw-leading-tight tw-mt-0.5 sm:tw-mt-1">
						Grade {{ activeStudent?.grade ?? activeStudent?.student?.grade }}
					</div>
				</div>
				<span class="tw-shrink-0 tw-text-xs sm:tw-text-sm tw-font-semibold tw-text-white/90 tw-bg-white/10 tw-px-2.5 sm:tw-px-3.5 tw-py-1 sm:tw-py-1.5 tw-rounded-full tw-border tw-border-white/15 tw-whitespace-nowrap">
					{{ scoreStorageService.count }} score{{ scoreStorageService.count > 1 ? 's' : '' }}
				</span>
			</div>

			<div class="tw-px-4 tw-py-3 sm:tw-px-8 sm:tw-py-5 tw-min-h-0 tw-grid tw-grid-rows-[auto_minmax(0,1fr)] tw-gap-2 sm:tw-gap-4 tw-overflow-hidden">
				<div class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600 tw-shrink-0">
					<i class="fa fa-calendar tw-text-gray-400"></i>
					<ng-container *ngIf="isTransformLmsAssessment(); else screenerReviewDate">
						<span
							*ngIf="!showDateSelector"
							class="tw-cursor-pointer hover:tw-text-[#243670] tw-transition-colors tw-font-medium"
							(click)="toggleDateSelector()">
							{{ selectedDate | date:'MM/dd/yyyy':'UTC' }}
						</span>
						<input
							*ngIf="showDateSelector"
							type="date"
							[(ngModel)]="selectedDate"
							class="tw-border tw-border-gray-300 tw-rounded-lg tw-px-2.5 tw-py-1 tw-text-sm focus:tw-ring-2 focus:tw-ring-[#243670]/20 focus:tw-border-[#243670] tw-outline-none"
							(blur)="toggleDateSelector()" />
					</ng-container>
					<ng-template #screenerReviewDate>
						<span class="tw-font-medium">{{ selectedDate | date:'MM/dd/yyyy':'UTC' }}</span>
					</ng-template>
				</div>

				<div class="para-lms-score-review-overlay__scores tw-flex tw-flex-col tw-gap-2 sm:tw-gap-2.5 confirm-score-list">
					<app-stored-score-row
						*ngFor="let score of scoreStorageService.storedScores | keyvalue"
						[assessment]="score.value"
						[storageKey]="score.key"
						[allowDelete]="isTransformLmsAssessment()"
						[allowRescore]="!isLocked"
						(deleteScore)="deleteScore($event)"
						(rescore)="navigateToChallengeForRescore($event)">
					</app-stored-score-row>
				</div>
			</div>

			<div class="tw-px-4 tw-py-3 sm:tw-px-8 sm:tw-py-4 tw-bg-gray-50 tw-border-t tw-border-gray-100 tw-flex tw-flex-col-reverse sm:tw-flex-row sm:tw-items-center sm:tw-justify-between tw-gap-2 sm:tw-gap-3 tw-shrink-0">
				<button
					type="button"
					(click)="goBackFromConfirmation()"
					class="tw-w-full sm:tw-w-auto tw-px-5 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-600 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg hover:tw-bg-gray-50 hover:tw-border-gray-300 tw-transition-all tw-shadow-sm tw-min-h-[44px]">
					<i class="fa fa-arrow-left tw-mr-1.5 tw-text-xs"></i> Back
				</button>
				<button
					type="button"
					(click)="submitScore()"
					[disabled]="isSubmitting"
					class="tw-w-full sm:tw-w-auto tw-justify-center tw-px-6 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-bg-[#28A745] tw-border tw-border-[#28A745] tw-rounded-lg hover:tw-bg-[#218838] tw-transition-all tw-shadow-sm hover:tw-shadow-md tw-flex tw-items-center tw-gap-2 tw-min-h-[44px] [disabled]:tw-opacity-70 [disabled]:tw-cursor-not-allowed">
					<span *ngIf="!isSubmitting">Submit {{ scoreStorageService.count }} Score{{ scoreStorageService.count > 1 ? 's' : '' }}</span>
					<span *ngIf="isSubmitting">Submitting...</span>
					<i *ngIf="!isSubmitting" class="fa fa-check"></i>
					<i *ngIf="isSubmitting" class="fa fa-circle-notch tw-animate-spin"></i>
				</button>
			</div>
		</div>
	</div>
</ng-template>

<div
	*ngIf="showCloseConfirm"
	class="tw-fixed tw-inset-0 tw-z-[50100] tw-flex tw-items-center tw-justify-center">
	<div class="overlay-fade tw-absolute tw-inset-0 tw-bg-black/50 tw-backdrop-blur-sm" (click)="cancelCloseDrawer()"></div>
	<div class="confirm-card tw-relative tw-max-w-sm tw-w-full tw-mx-4 tw-bg-white tw-rounded-2xl tw-shadow-2xl tw-overflow-hidden">
		<div class="tw-bg-[#243670] tw-px-6 tw-py-3 tw-flex tw-items-center tw-gap-3">
			<app-para-student-badge
				class="tw-w-7 tw-h-7 tw-rounded-lg"
				[student]="activeStudent"
				[milestoneOverlay]="lmsStudentBadgeMilestoneOverlay"
			></app-para-student-badge>
			<div>
				<div class="tw-text-white tw-text-sm tw-font-black tw-leading-tight">
					<span data-para-redact>{{ activeStudent?.student?.firstName }} {{ activeStudent?.student?.lastName }}</span>
				</div>
				<div *ngIf="activeStudent?.grade ?? activeStudent?.student?.grade" class="tw-text-white/70 tw-text-xs tw-font-semibold tw-leading-tight tw-mt-0.5">
					Grade {{ activeStudent?.grade ?? activeStudent?.student?.grade }}
				</div>
				<div class="tw-text-white/60 tw-text-xs">
					{{ getCurrentChallenge()?.label || activeStudent?.challange?.highestChallenge?.challengeLabel }}
				</div>
			</div>
		</div>
		<div class="tw-px-6 tw-pt-5 tw-pb-4 tw-text-center">
			<div class="tw-w-12 tw-h-12 tw-rounded-full tw-bg-red-100 tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
				<i class="fa fa-exclamation-triangle tw-text-red-500 tw-text-lg"></i>
			</div>
			<h3 class="tw-text-lg tw-font-semibold tw-text-gray-900 tw-m-0 tw-mb-2">Discard unsaved score{{ scoreStorageService.count > 1 ? 's' : '' }}?</h3>
			<p class="tw-text-sm tw-text-gray-500 tw-m-0 tw-leading-relaxed">
				You have <strong class="tw-text-gray-700">{{ scoreStorageService.count }}</strong>
				unsaved score{{ scoreStorageService.count > 1 ? 's' : '' }} that {{ scoreStorageService.count > 1 ? "haven't" : "hasn't" }} been submitted. {{ confirmDiscardActionLabel }} will discard {{ scoreStorageService.count > 1 ? 'them' : 'it' }}.
			</p>
		</div>
		<div class="tw-px-6 tw-py-4 tw-bg-gray-50 tw-border-t tw-border-gray-100 tw-flex tw-gap-3">
			<button
				type="button"
				(click)="cancelCloseDrawer()"
				class="tw-flex-1 tw-px-4 tw-py-2.5 tw-text-sm tw-font-medium tw-text-gray-700 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg hover:tw-bg-gray-50 tw-transition-colors tw-cursor-pointer tw-shadow-sm">
				Keep Scoring
			</button>
			<button
				type="button"
				data-testid="para-lms-confirm-discard"
				(click)="confirmCloseDrawer()"
				class="tw-flex-1 tw-px-4 tw-py-2.5 tw-text-sm tw-font-semibold tw-text-white tw-bg-red-500 tw-border tw-border-red-500 tw-rounded-lg hover:tw-bg-red-600 tw-transition-colors tw-cursor-pointer tw-shadow-sm">
				{{ confirmDiscardButtonLabel }}
			</button>
		</div>
	</div>
</div>
